import {ActionEnum} from "../action.enum";
import {UserBasicInfo, UserLoginData} from "../../models/user/user-update.model";

export namespace UserPasswordAction {

  export class LoadPasswordData {
    static readonly type = ActionEnum.USER_PASSWORD_LOAD_DATA;
    constructor (public userId: string) {}
  }

  export class UpdatePassword {
    static readonly type = ActionEnum.USER_PASSWORD_UPDATE_PASSWORD;
    constructor (public password: string) {}
  }

  export class ResetFailedState {
    static readonly type = ActionEnum.USER_PASSWORD_RESET_FAILED_STATE;
    constructor () {}
  }

}
